import templateUrl from "emun.salesrep/top-selling-categories.htm";
import $appConfig from "servicestack/config";

export class TopSellingCategoriesController {
  constructor($window, $rootScope, createAutoQuery) {
    let $ctrl = this;
    $ctrl.productImage = $appConfig.productImage.bind($appConfig);

    var url = "QueryTopSellingCategories.json?OrderBy=-YTD";
    if ($ctrl.customer) {
      url = url + "&CustomerId=" + $ctrl.customer.id;
    }
    if ($ctrl.rep) {
      url = url + "&RepId=" + $ctrl.rep.id;
    }

    this.topCategories = createAutoQuery({
      url: url,
      autoLoad: true,
      pageSize: 10,
    });
  }
  downloadData() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      "" + $ctrl.topCategories.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }
}
export default {
  bindings: {
    rep: "<",
    customer: "<",
    context: "@",
    title: "@",
  },
  controller: TopSellingCategoriesController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
